var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14404 23.8292C10.6576 26.4374 13.3773 28 16.4044 28C19.4316 28 22.1513 26.4374 23.6648 23.8292C25.1784 21.2209 25.1784 18.1075 23.6648 15.4992L17.2795 4.50226C16.8892 3.83258 15.9196 3.83258 15.5294 4.50226L9.14404 15.4992C7.61865 18.1075 7.61865 21.2209 9.14404 23.8292ZM14.6071 9.73051L15.9669 7.38074C16.1561 7.05177 16.6528 7.05177 16.8419 7.38074L22.0803 16.4039C23.0381 18.0605 23.2273 19.9755 22.6242 21.7379C22.5651 21.4559 22.4705 21.1622 22.3523 20.8684C21.631 19.0474 19.9873 17.6492 17.4805 16.7093C15.7541 16.0631 14.6544 15.0997 14.2169 13.8661C13.6493 12.2683 14.2523 10.5294 14.6071 9.73051ZM12.2776 13.7251L10.7286 16.4039C9.54609 18.4482 9.54609 20.8802 10.7286 22.9245C11.911 24.9688 14.0395 26.1789 16.4044 26.1789C17.9771 26.1789 19.4434 25.6385 20.6022 24.6868C20.7559 24.3109 21.2171 22.9362 20.6377 21.5146C20.1056 20.1987 18.8285 19.1531 16.8301 18.4012C14.5834 17.5553 13.1172 16.2276 12.4786 14.4653C12.3958 14.2186 12.3367 13.9719 12.2776 13.7251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSui);
export default __webpack_public_path__ + "static/media/SUI.b7352f1139914cc4d92af2ee1aaa874d.svg";
export { ForwardRef as ReactComponent };